export default "__VITE_ASSET__4e6c696c__"